<div class="app-toast-holder" *ngIf="toastService.singleToast || toastService.multipleToasts">
  <div class="outer-content">
    <div class="inner-content" [class.opened]="toastService.toasts.length > 0" [class.closed]="toastService.isClose">

      <app-toast *ngIf="toastService.singleToast" [toastContent]="toastService.singleToast" (onClose)="close($event)" (onOpen)="open($event)" [title]="toastTitle" ></app-toast>
      <app-toast *ngIf="toastService.multipleToasts" [toastContent]="toastService.multipleToasts" (onClose)="close($event)" (onOpen)="openNotificationMenu($event)" [title]="toastTitle"></app-toast>
    </div>
  </div>
</div>
